import { iconsNameList } from '@/uikit/components/AppSvgIcon/iconsList';
import { uiIcons } from '@/uikit/components/AppSvgIconNew/templates';
import {
  IModalCallBacks,
  IModalConfig,
} from '@/uikit/components/AppModal/types';
import { AppModal } from '@/uikit';
import Vue from 'vue';

interface IUiSevice {
  $modals: {};
}

(process as any).browser
  ? ((window as any).$uiKit = {
      $modals: {},
    })
  : null;

export const uiSettings = {
  /** для внутренних целей*/
  dataService: (process as any).browser
    ? ((window as any).$uiKit as IUiSevice)
    : (null as any),
  /** модалка */
  $modal: {
    show: modalShow,
    close: modalClose,
    update: updateData,
    closeAll: modalCloseAll,
  },
  /** имя иконки */
  IconSvgName: iconsNameList,
  Color: {
    purple: '#7665cd',
    blue: 'blue',
    none: 'none',
    darkGray: 'rgba(0,0,0,0.8)',
    lightGray: 'rgba(0,0,0,0.3)',
    gray: 'rgba(0,0,0,0.5)',
  },
  AppSvgIcon: {
    size: {
      small: 'small',
      large: 'large',
    },
  },
  IconSvgComponents: uiIcons,
  AppButton: {
    iconPosition: {
      prefix: 'prefix',
      center: 'center',
      none: 'none',
    },
    textWeight: {
      regular: 'regular',
      bold: 'bold',
    },
    textSize: {
      small: 'small',
      normal: 'normal',
      large: 'large',
    },
    buttonTheme: {
      default: 'default',
    },
  },
};

function modalClose(name: string) {
  uiSettings.dataService.$modals[name].close();
}

function updateData(name: string, payload: any | undefined = undefined) {
  uiSettings.dataService.$modals[name].update(payload);
}

function modalCloseAll() {
  for (const key in uiSettings.dataService.$modals) {
    uiSettings.dataService.$modals[key].close();
  }
}

async function modalShow(
  name: string,
  config: IModalConfig,
  callBacks?: IModalCallBacks
) {
  if (uiSettings.dataService.$modals[name]) {
    return;
  }
  callBacks?.show ? await callBacks.show() : null; /// запускаем функцию колл-бек перед открытием модалки, если есть
  const ComponentClass = Vue.extend(AppModal);
  let instance: any = new ComponentClass({
    parent: config.bind ? config.bind : undefined, // передаём контекст в модалку (если забиндить в основном инстансе на функцию, то будет доступ с сторе роутам и тд)
    propsData: {
      config: {
        ...config,
        name: name,
      },
    },
  });
  instance.$mount();
  document.body.appendChild(instance.$el);

  const close = async () => {
    instance.$destroy();
    instance.$el.remove();
    instance = null;
    callBacks?.close ? await callBacks.close() : null; /// запускаем функцию колл-бек после закрытия модалки, если есть
    delete uiSettings.dataService.$modals[name];
  };

  const update = async (data: any) => {
    callBacks?.update ? await callBacks.update(data) : null;
  };

  uiSettings.dataService.$modals = {
    ...uiSettings.dataService.$modals,
    [name]: {
      close: close,
      update: update,
    },
  };
}



// WEBPACK FOOTER //
// ./src/tools/ui/uiSettings.ts